var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoCharging(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 96 960 960",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m337 842 88-140h-53V597l-87 140h52v105ZM220 504h269V276H220v228Zm0 372h269V564H220v312Zm-60 60V276q0-24 18-42t42-18h269q24 0 42 18t18 42v288h65q20.714 0 35.357 14.643T664 614v219q0 22 17.5 36.5T722 884q23 0 43-14.5t20-36.5V446h-15q-12.75 0-21.375-8.625T740 416v-90h20v-50h30v50h40v-50h30v50h20v90q0 12.75-8.625 21.375T850 446h-15v386.691Q835 876 801 906t-79.181 30q-44.155 0-75.987-30Q614 876 614 833V614h-65v322H160Zm329-60H220h269Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCharging);
export default __webpack_public_path__ + "static/media/ico_charging.847a695b30500bcd14fb20dac6d036ba.svg";
export { ForwardRef as ReactComponent };